import React from 'react'

const style = {
   status: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: 'rgba(55,200,70,0.15)',
      color: '#37C846',
      padding: '4px 14px',
      borderRadius: '40px'
   },
   dot: {
      height: '12px',
      width: '12px',
      borderRadius: '50%',
      backgroundColor: '#37C846',
      display: 'inline-block'
   }
}

export default function Active() {
   return (
      <span style={style.status}>
         <span style={style.dot} />
         &nbsp;Activo
      </span>
   )
}
